import { FertilizerTypeEnum } from 'src/app/crop-aid/crop-aid.model';

export enum FertilizerType {
  InitialStock = 'InitialStock',
  NotDelivered = 'NotDelivered',
  Delivered = 'Delivered',
  Dispatched = 'Dispatched',
  ClosingStock = 'ClosingStock',
}

export enum FertilizerSource {
  Unknown = 'Unknown',
  ExternalVDM = 'ExternalVDM',
  ExternalVZC = 'ExternalVZC',
  Advice = 'Advice',
  Manual = 'Manual',
  Delivery = 'Delivery',
}

export interface AbstractFertilizer {
  dosage: number;
  totalNitrogen: number;
  totalPhosphate: number;
  periodId: number;
  soilTypeId?: number;
  comment: string;
  fertilizerType: FertilizerType;
  fertilizerSource: FertilizerSource;
  manureCode: number;
}

export interface AbstractFertilizerRequest extends AbstractFertilizer {
  fertilizerId?: string;
}

export interface Fertilizer extends AbstractFertilizer, FertilizerResponse {
  cropAidId: number;
}

export interface FertilizerData extends Fertilizer {
  cropAidName: string;
  cropAidFertilizerType: FertilizerTypeEnum;
  soilTypeName: string;
  salesOrderPeriodName: string;
}

export interface FertilizerDataByType {
  fertilizerType: FertilizerType;
  fertilizerData: FertilizerData[];
}

export interface FertilizerForm extends AbstractFertilizerRequest {
  cropAidId: number;
}

export interface FertilizerRequest extends AbstractFertilizerRequest {
  cropAidId: number;
}

export interface PostFertilizersResponse {
  ids: string[];
}

export interface FertilizerResponse {
  id: string;
  comment: string;
}

export interface FertilizerFromDelivery {
  cropAidId: number;
  soilTypeId?: number;
  dosage: number;
  comment: string;
  totalNitrogen: number;
  totalPhosphate: number;
  periodId: number;
  fertilizerType?: FertilizerType;
  manureCode?: number;
}

export interface MineralBalanceResponse {
  fertilizers: FertilizerFromDelivery[];
}

export interface AdvisedFertilizerResponse {
  fertilizers: FertilizerFromDelivery[];
}

export interface DeleteFertilizersBySourceRequest {
  manureSpaceId: number;
  fertilizerSource: FertilizerSource;
  fertilizerTypes: FertilizerType[];
}

export interface DeleteFertilizersByManureCode {
  manureCode: number;
  cropAidId: number;
  soilTypeId?: number;
  fertilizerType: FertilizerType;
}

export enum VDMTableType {
  Received = 'Received',
  Dispatched = 'Dispatched',
}
